import { render } from "./UnidadesPage.vue?vue&type=template&id=4b4ff8f6&scoped=true"
import script from "./UnidadesPage.vue?vue&type=script&lang=js"
export * from "./UnidadesPage.vue?vue&type=script&lang=js"

import "./UnidadesPage.vue?vue&type=style&index=0&id=4b4ff8f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4ff8f6"]])

export default __exports__